export default "__VITE_ASSET__ktOwuimR__"